const Loading = () => (
  <div className="flex items-center justify-center h-full w-full">
    Loading...
  </div>
);
export default Loading;
